<template>
  <div class="performance-management-container">
    <div class="header">
      <div class="header-content">
        <div class="header-left">
          <h1>📊 绩效管理驾驶舱</h1>
          <div class="sub">管理部门 · 绩效数据总览 | 支持申请与审核流程</div>
        </div>
        <el-button
          class="back-button"
          icon="el-icon-back"
          @click="handleGoBack"
        >
          返回
        </el-button>
      </div>
    </div>

    <!-- Tab 导航 -->
    <div class="tab-bar">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="📋 我的绩效" name="myPerformance"></el-tab-pane>
        <el-tab-pane label="📤 绩效上传" name="upload"></el-tab-pane>
        <el-tab-pane label="⏳ 待我审核" name="pendingReview"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 页面1：我的绩效 -->
    <div v-show="activeTab === 'myPerformance'" class="page-container">
      <MyPerformance
        :data-list="myPerformData"
        :filters="myPerformanceFilters"
        :pagination="myPerformancePagination"
        :loading="myPerformanceLoading"
        @query="handleMyPerformanceQuery"
        @reset="handleMyPerformanceReset"
        @size-change="handleMyPerformanceSizeChange"
        @current-change="handleMyPerformanceCurrentChange"
      />
    </div>

    <!-- 页面2：绩效上传 -->
    <div v-show="activeTab === 'upload'" class="page-container upload-page">
      <PerformanceUpload
        :current-flow="currentFlow"
        :is-employee-editing="isEmployeeEditing"
        :form-data="formData"
        :department-list="Department"
        :dept-leaders="deptLeaders"
        :year-options="yearOptions"
        :period-options="periodOptions"
        :indicator-list="indicatorList"
        :bonus-weight="bonusWeight"
        :bonus-data="bonusData"
        :approval-data="approvalData"
        @kpi-type-change="handleKpiTypeChange"
        @add-indicator="addIndicator"
        @delete-indicator="deleteIndicator"
        @employee-submit="employeeSubmitAction"
        @dept-submit="deptSubmitToHigher"
        @view-reward-system="viewRewardSystem"
      />
    </div>

    <!-- 页面3：待我审核 -->
    <div v-show="activeTab === 'pendingReview'" class="page-container">
      <PendingReview
        :data-list="pendingReviews"
        :filters="pendingReviewFilters"
        :pagination="pendingReviewPagination"
        :loading="pendingReviewLoading"
        @query="handlePendingReviewQuery"
        @reset="handlePendingReviewReset"
        @size-change="handlePendingReviewSizeChange"
        @current-change="handlePendingReviewCurrentChange"
        @submit-score="submitScore"
      />
    </div>

    <!-- 文档预览对话框 -->
    <el-dialog
      title="绩效管理奖惩制度"
      :visible.sync="showDocDialog"
      width="80%"
      top="5vh"
      custom-class="doc-preview-dialog"
    >
      <div class="doc-content" v-html="docContent"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDocDialog = false">关 闭</el-button>
        <el-button type="primary" @click="downloadOriginalDoc"
          >下载原文档</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mammoth from 'mammoth';
import {
  getDepartments,
  getCompaniesUsers,
  saveDraft,
  saveSubmit,
  getMine,
  getReview,
} from '@/API/apply/apply.js';
import MyPerformance from './components/MyPerformance.vue';
import PerformanceUpload from './components/PerformanceUpload.vue';
import PendingReview from './components/PendingReview.vue';

export default {
  name: 'PerformanceManagement',
  components: {
    MyPerformance,
    PerformanceUpload,
    PendingReview,
  },
  data() {
    return {
      activeTab: 'myPerformance',

      // 我的绩效筛选条件
      myPerformanceFilters: {
        year: 'all',
        quarter: 'all',
        status: 'all',
      },

      // 待我审核筛选条件
      pendingReviewFilters: {
        year: 'all',
        dept: 'all',
        status: 'all',
      },

      // 绩效上传相关数据
      currentFlow: 'employee',
      userDetail: JSON.parse(localStorage.getItem('ordinaryUser'))?.userDetail,
      isEmployeeEditing: true,
      showDocDialog: false,
      docContent: '',
      formData: {
        fillDate: new Date().toISOString().split('T')[0],
        empName:
          JSON.parse(localStorage.getItem('ordinaryUser'))?.userDetail
            ?.username || '张三',
        dept: '',
        position: '',
        year: '',
        kpiType: '',
        periodDetail: '',
        deptLeader: '',
        selectedDeptLeaderName: '',
      },
      Department: [],
      deptLeaders: [],
      periodOptions: [],
      yearOptions: [],
      indicatorList: [],
      bonusWeight: 10,
      bonusData: {
        highlightDesc: '',
        deductReason: '',
      },
      approvalData: {
        deptComment: '待部门领导审批',
        deptDate: '',
        higherComment: '-- 流程未到 --',
        higherLeader: '',
        higherName: '',
        higherDate: '',
      },
      finalScore: null,
      currentCompanyId: null,

      // 我的绩效数据
      myPerformData: [],

      // 分页参数
      myPerformancePagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      // 加载状态
      myPerformanceLoading: false,

      // 待我审核数据
      pendingReviews: [],

      // 待我审核分页参数
      pendingReviewPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      // 待我审核加载状态
      pendingReviewLoading: false,
    };
  },
  watch: {
    'formData.year': {
      handler(newVal) {
        if (newVal && this.formData.kpiType === '年度') {
          this.generatePeriodOptions();
        }
      },
    },
  },
  mounted() {
    this.currentCompanyId = this.userDetail?.companyInfo?.companyId;
    if (this.currentCompanyId) {
      this.getDeptLeaders();
      this.getCompaniesUsers();
    }
    this.generateYearOptions();
    this.generatePeriodOptions();

    // 加载我的绩效数据
    this.loadMyPerformanceData();
  },
  methods: {
    handleGoBack() {
      // 返回上一页
      this.$router.go(-1);
    },
    handleTabClick(tab) {
      console.log('切换到:', tab.name);

      // 如果切换到我的绩效 Tab，重新加载数据
      if (tab.name === 'myPerformance') {
        this.loadMyPerformanceData();
      }

      // 如果切换到待我审核 Tab，重新加载数据
      if (tab.name === 'pendingReview') {
        this.loadPendingReviewData();
      }
    },

    // 加载我的绩效数据
    loadMyPerformanceData() {
      const userId = this.userDetail?.userId;
      if (!userId) {
        this.$message.warning('未获取到用户信息');
        return;
      }

      this.myPerformanceLoading = true;

      // 构建请求参数
      const params = {
        userId: userId,
        pageNum: this.myPerformancePagination.pageNum,
        pageSize: this.myPerformancePagination.pageSize,
      };

      // 添加可选参数
      if (this.myPerformanceFilters.year !== 'all') {
        params.assessmentYear = this.myPerformanceFilters.year;
      }

      if (this.myPerformanceFilters.quarter !== 'all') {
        params.periodDetail = this.myPerformanceFilters.quarter;
      }

      // 根据状态筛选（如果需要）
      if (this.myPerformanceFilters.status !== 'all') {
        params.status = this.myPerformanceFilters.status;
      }

      getMine(params)
        .then((res) => {
          if (res.code === 200) {
            const responseData = res.data;
            // 处理分页总数
            if (responseData.total !== undefined) {
              this.myPerformancePagination.total = responseData.total;
            }
            // 处理数据列表
            let list = [];
            if (responseData.records && Array.isArray(responseData.records)) {
              list = responseData.records;
            } else if (Array.isArray(responseData)) {
              list = responseData;
            }

            // 转换数据格式
            this.myPerformData = list.map((item) => ({
              id: item.id,
              period:
                item.periodDetail ||
                `${item.assessmentYear}${this.getPeriodLabel(
                  item.periodDetail,
                )}`,
              type: this.getAssessmentTypeLabel(item.assessmentType),
              score: item.finalScore || '--',
              status: this.getStatusLabel(item.processStatus),
              submitDate: item.fillDate,
              dept: item.departmentName || '',
              quarterKey: item.periodDetail || '',
              year: item.assessmentYear || '',
            }));
          } else {
            this.$message.error(res.message || '获取绩效数据失败');
          }
        })
        .catch((error) => {
          console.error('获取绩效数据失败:', error);
          this.$message.error('获取绩效数据失败，请重试');
        })
        .finally(() => {
          this.myPerformanceLoading = false;
        });
    },

    // 辅助方法：获取周期标签
    getPeriodLabel(periodDetail) {
      if (!periodDetail) return '';

      const periodMap = {
        Q1: '一季度',
        Q2: '二季度',
        Q3: '三季度',
        Q4: '四季度',
        '1月': '年1月',
        '2月': '年2月',
        '3月': '年3月',
        '4月': '年4月',
        '5月': '年5月',
        '6月': '年6月',
        '7月': '年7月',
        '8月': '年8月',
        '9月': '年9月',
        '10月': '年10月',
        '11月': '年11月',
        '12月': '年12月',
      };
      return periodMap[periodDetail] || '';
    },

    // 辅助方法：获取考核类型标签
    getAssessmentTypeLabel(type) {
      if (!type) return '考核';

      const typeMap = {
        年度: '年度考核',
        季度: '季度考核',
        月度: '月度考核',
      };
      return typeMap[type] || type;
    },

    // 辅助方法：获取状态标签
    getStatusLabel(status) {
      if (status === null || status === undefined) return '未知';
      return status;
    },

    // 我的绩效查询
    handleMyPerformanceQuery() {
      console.log('执行我的绩效查询');
      // 重置页码为1，重新加载数据
      this.myPerformancePagination.pageNum = 1;
      this.loadMyPerformanceData();
    },

    // 重置筛选条件
    handleMyPerformanceReset() {
      console.log('重置筛选条件');
      // 重置筛选条件
      this.myPerformanceFilters.year = 'all';
      this.myPerformanceFilters.quarter = 'all';
      this.myPerformanceFilters.status = 'all';

      // 重置页码并重新加载
      this.myPerformancePagination.pageNum = 1;
      this.loadMyPerformanceData();
    },

    // 改变每页条数
    handleMyPerformanceSizeChange(val) {
      console.log('每页条数改变:', val);
      this.myPerformancePagination.pageSize = val;
      this.myPerformancePagination.pageNum = 1; // 重置到第一页
      this.loadMyPerformanceData();
    },

    // 改变当前页
    handleMyPerformanceCurrentChange(val) {
      console.log('当前页改变:', val);
      this.myPerformancePagination.pageNum = val;
      this.loadMyPerformanceData();
    },

    // 待我审核查询
    handlePendingReviewQuery() {
      console.log('执行待我审核查询');
      // 重置页码为1，重新加载数据
      this.pendingReviewPagination.pageNum = 1;
      this.loadPendingReviewData();
    },

    // 重置待我审核筛选条件
    handlePendingReviewReset() {
      console.log('重置待我审核筛选条件');
      // 重置筛选条件
      this.pendingReviewFilters.year = 'all';
      this.pendingReviewFilters.dept = 'all';
      this.pendingReviewFilters.status = 'all';

      // 重置页码并重新加载
      this.pendingReviewPagination.pageNum = 1;
      this.loadPendingReviewData();
    },

    // 改变待我审核每页条数
    handlePendingReviewSizeChange(val) {
      console.log('待我审核每页条数改变:', val);
      this.pendingReviewPagination.pageSize = val;
      this.pendingReviewPagination.pageNum = 1; // 重置到第一页
      this.loadPendingReviewData();
    },

    // 改变待我审核当前页
    handlePendingReviewCurrentChange(val) {
      console.log('待我审核当前页改变:', val);
      this.pendingReviewPagination.pageNum = val;
      this.loadPendingReviewData();
    },

    // 加载待我审核数据
    loadPendingReviewData() {
      const reviewerUserId = this.userDetail?.userId;
      if (!reviewerUserId) {
        this.$message.warning('未获取到用户信息');
        return;
      }

      this.pendingReviewLoading = true;

      // 构建请求参数
      const params = {
        reviewerUserId: reviewerUserId,
        pageNum: this.pendingReviewPagination.pageNum,
        pageSize: this.pendingReviewPagination.pageSize,
      };

      // 添加可选参数
      if (this.pendingReviewFilters.year !== 'all') {
        params.assessmentYear = this.pendingReviewFilters.year;
      }

      if (this.pendingReviewFilters.dept !== 'all') {
        params.departmentId = this.pendingReviewFilters.dept;
      }

      getReview(params)
        .then((res) => {
          if (res.code === 200) {
            const responseData = res.data;

            // 处理分页总数
            if (responseData.total !== undefined) {
              this.pendingReviewPagination.total = responseData.total;
            }

            // 处理数据列表
            let list = [];
            if (responseData.records && Array.isArray(responseData.records)) {
              list = responseData.records;
            } else if (Array.isArray(responseData)) {
              list = responseData;
            }

            // 转换数据格式
            this.pendingReviews = list.map((item) => ({
              assessmentType: this.getAssessmentTypeLabel(item.assessmentType),
              companyName: item.companyName || '',
              assessmentYear: item.assessmentYear || '',
              departmentName: item.departmentName || '',
              deptLeaderSubmitTime: item.deptLeaderSubmitTime || '',
              employeeSubmitTime: item.employeeSubmitTime || '',
              fillDate: item.fillDate || item.createTime,
              finalScore: item.finalScore || '--',
              gmSubmitTime: item.gmSubmitTime || '',
              id: item.id,
              periodDetail:
                item.periodDetail ||
                `${item.assessmentYear}${this.getPeriodLabel(
                  item.periodDetail,
                )}`,
              processStatus: this.getPendingReviewStatusLabel(
                item.processStatus,
              ),
              userId: item.userId,
              userName: item.empName || item.userName || '',
            }));
          } else {
            this.$message.error(res.message || '获取待审核数据失败');
          }
        })
        .catch((error) => {
          console.error('获取待审核数据失败:', error);
          this.$message.error('获取待审核数据失败，请重试');
        })
        .finally(() => {
          this.pendingReviewLoading = false;
        });
    },

    // 辅助方法：获取待我审核状态标签
    getPendingReviewStatusLabel(status) {
      if (status === null || status === undefined) return '未知';

      const statusMap = {
        1: '待部门领导审核',
        2: '待总经理复核',
        3: '审核通过',
        4: '审核不通过',
      };

      return statusMap[status] || '未知';
    },

    // ========== 绩效上传相关方法 ==========
    getDeptLeaders() {
      getDepartments(this.currentCompanyId).then((res) => {
        this.Department = res.data.map((item) => ({
          value: item.id,
          label: item.deptName,
        }));
      });
    },
    getCompaniesUsers() {
      getCompaniesUsers(this.currentCompanyId).then((res) => {
        this.deptLeaders = res.data.map((item) => ({
          value: item.userId,
          label: item.username,
        }));
      });
    },
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      this.yearOptions = [];
      for (let i = 0; i < 10; i++) {
        const year = currentYear - i;
        this.yearOptions.push({ value: `${year}`, label: `${year}年` });
      }
      if (!this.formData.year) {
        this.formData.year = `${currentYear}`;
      }
    },
    generatePeriodOptions() {
      const currentYear = new Date().getFullYear();
      const selectedYear = this.formData.year
        ? parseInt(this.formData.year)
        : currentYear;

      if (this.formData.kpiType === '年度') {
        this.periodOptions = [];
        for (let i = 0; i < 5; i++) {
          const year = selectedYear - i;
          this.periodOptions.push({ value: `${year}年`, label: `${year}年` });
        }
      } else if (this.formData.kpiType === '季度') {
        this.periodOptions = [
          { value: 'Q1', label: 'Q1' },
          { value: 'Q2', label: 'Q2' },
          { value: 'Q3', label: 'Q3' },
          { value: 'Q4', label: 'Q4' },
        ];
      } else if (this.formData.kpiType === '月度') {
        this.periodOptions = [
          { value: '1月', label: '一月' },
          { value: '2月', label: '二月' },
          { value: '3月', label: '三月' },
          { value: '4月', label: '四月' },
          { value: '5月', label: '五月' },
          { value: '6月', label: '六月' },
          { value: '7月', label: '七月' },
          { value: '8月', label: '八月' },
          { value: '9月', label: '九月' },
          { value: '10月', label: '十月' },
          { value: '11月', label: '十一月' },
          { value: '12月', label: '十二月' },
        ];
      } else {
        this.periodOptions = [];
      }

      this.formData.periodDetail = '';
    },
    handleKpiTypeChange(value) {
      this.generatePeriodOptions();
    },
    addIndicator() {
      if (this.currentFlow !== 'employee') {
        this.$message.warning('只有员工填写阶段可新增指标');
        return;
      }
      this.indicatorList.push({
        category: '',
        requirement: '',
        implementation: '',
        weight: 10,
      });
    },
    deleteIndicator(index) {
      if (this.currentFlow !== 'employee') {
        this.$message.warning('非员工阶段不能删除指标');
        return;
      }
      this.indicatorList.splice(index, 1);
    },
    employeeSubmitAction(submitData) {
      if (this.currentFlow !== 'employee') {
        this.$message.warning('已提交不可重复操作');
        return;
      }

      // 打印接收到的完整数据
      console.log('=== 父组件接收到的提交数据 ===');
      console.log('上传信息:', submitData);

      this.$confirm(
        `员工【${submitData.userName}】已提交绩效表给部门领导\n` +
          `包含动态考核指标 ${submitData.items.length} 项。\n` +
          `权重分总和：${submitData.totalWeightScore} 分（已验证为100分）\n` +
          `亮点评分与扣分项描述已提交，等待领导评定。`,
        '提交确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success',
        },
      )
        .then(() => {
          saveDraft(submitData).then((res) => {
            if (res.code === 200) {
              saveSubmit({ userId: submitData.userId }, res.data).then(
                (rep) => {
                  if (rep.code === 200) {
                    this.$message.success('✅ 已提交部门领导审批');
                    this.currentFlow = 'deptReview';
                    // 提交成功后刷新页面
                    setTimeout(() => {
                      window.location.reload();
                    }, 500);
                  }
                },
              );
            }
          });
        })
        .catch(() => {});
    },
    deptSubmitToHigher(comment) {
      if (this.currentFlow !== 'deptReview') {
        this.$message.warning('当前非部门领导审批环节');
        return;
      }

      if (!comment || !comment.trim()) {
        this.$message.warning('请填写部门领导评语');
        return;
      }

      let totalWeight = this.indicatorList.reduce(
        (sum, item) => sum + (item.weight || 0),
        0,
      );
      totalWeight += this.bonusWeight || 0;

      let baseScore = Math.min(100, totalWeight * 0.92);
      let bonusMock = 8.5;
      let deductMock = 0;
      let finalSim = baseScore + bonusMock - deductMock;
      finalSim = Math.min(100, Math.max(0, finalSim));

      this.finalScore = finalSim.toFixed(1);

      this.$alert(
        `部门领导已完成审批，评语：${comment}\n初步考核总分(含亮点加减分预填)：${this.finalScore}分，提交至上级复核。`,
        '审批提示',
        { confirmButtonText: '确定', type: 'success' },
      ).then(() => {
        this.currentFlow = 'higherReview';
        this.approvalData.higherComment =
          '经复核，各项指标均符合预期，给予核定总分。';
        this.approvalData.higherDate = new Date().toISOString().split('T')[0];
        this.$message.success('已提交上级复核');
      });
    },
    viewRewardSystem() {
      this.showDocDialog = true;
      this.docContent =
        '<div style="text-align:center;padding:50px;color:#999;"><i class="el-icon-loading" style="font-size:24px;"></i><p style="margin-top:10px;">正在加载文档...</p></div>';
      // 使用相对路径，兼容本地和线上环境
      const docUrl = 'docs/绩效管理奖惩制度.docx';

      fetch(docUrl)
        .then((response) => {
          if (!response.ok) throw new Error('文件加载失败');
          return response.arrayBuffer();
        })
        .then((arrayBuffer) => mammoth.convertToHtml({ arrayBuffer }))
        .then((result) => {
          this.docContent =
            result.value ||
            '<div style="text-align:center;padding:50px;color:#f56c6c;"><p>文档内容为空</p></div>';
          if (result.messages && result.messages.length > 0) {
            console.warn('文档转换警告:', result.messages);
          }
        })
        .catch((error) => {
          console.error('文档加载失败:', error);
          this.docContent = `
            <div style="text-align:center;padding:50px;color:#f56c6c;">
              <i class="el-icon-warning" style="font-size:48px;"></i>
              <p style="margin-top:20px;font-size:16px;">文档加载失败</p>
              <p style="margin-top:10px;color:#999;">请确保文件存在于 docs/ 目录下</p>
              <el-button type="primary" style="margin-top:20px;" onclick="window.open('docs/绩效管理奖惩制度.docx', '_blank')">下载原文档查看</el-button>
            </div>
          `;
          this.$message.error('文档加载失败，您可以下载原文档查看');
        });
    },
    downloadOriginalDoc() {
      const docUrl = 'docs/绩效管理奖惩制度.docx';
      window.open(docUrl, '_blank');
    },


    // ========== 待我审核相关方法 ==========
    submitScore(row) {
      if (row.status !== '待审核') {
        this.$message.warning('该项已经完成审核，无法再次打分');
        return;
      }

      const newScore = row.tempScore;
      if (isNaN(newScore) || newScore < 0) {
        this.$message.error('请输入有效的分数');
        return;
      }
      if (newScore > 100) {
        this.$message.error('分数不能超过100');
        return;
      }

      this.$prompt(
        `为【${row.applicant}】 - ${row.period} 进行最终考核评分\n当前得分: ${newScore}\n请输入审核意见（可选）`,
        '审核意见',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: '同意该考核结果',
          inputPattern: /.+/,
          inputErrorMessage: '审核意见不能为空',
        },
      )
        .then(({ value }) => {
          row.assessmentScore = newScore;
          row.status = '审核通过';

          const matchedMy = this.myPerformData.find(
            (m) => m.period === row.period && m.dept === row.dept,
          );
          if (
            matchedMy &&
            (matchedMy.status === '已提交' || matchedMy.status === '草稿')
          ) {
            matchedMy.status = '审核通过';
            matchedMy.score = newScore;
          }

          this.$message.success(
            `✅ 已为 ${row.applicant} 完成打分，最终得分: ${newScore} 分，审核意见: ${value}`,
          );
        })
        .catch(() => {
          row.tempScore = row.assessmentScore;
        });
    },
  },
};
</script>

<style scoped lang="less">
.performance-management-container {
  width: 80%;
  margin: 30px auto;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.header {
  background: #ffffff;
  padding: 20px 28px 12px 28px;
  border-bottom: 1px solid #e9edf2;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-left {
      flex: 1;

      h1 {
        font-size: 24px;
        font-weight: 600;
        color: #0b2b3b;
        letter-spacing: -0.3px;
        margin-bottom: 6px;
      }

      .sub {
        font-size: 13px;
        color: #5f7f8c;
        margin-top: 0;
      }
    }
  }

  .back-button {
    flex-shrink: 0;
    margin-left: 20px;
    border-radius: 20px;
    padding: 8px 20px;
    font-size: 14px;
  }
}
.tab-bar {
  padding: 0 28px;
  background: white;
  border-bottom: 1px solid #e9edf2;

  /deep/ .el-tabs__header {
    margin: 0;
  }

  /deep/ .el-tabs__item {
    font-size: 14px;
    font-weight: 500;
    color: #5f7f8c;
    padding: 0 24px;
    height: 48px;
    line-height: 48px;

    &.is-active {
      color: #1e6f5c;
    }
  }

  /deep/ .el-tabs__active-bar {
    background-color: #1e6f5c;
  }
}

.page-container {
  padding: 24px 28px 28px 28px;
}

.upload-page {
  padding: 0;
}

/deep/ .doc-preview-dialog {
  .el-dialog__body {
    max-height: 65vh;
    overflow-y: auto;
    padding: 30px;
    background-color: #fafef7;
  }

  .doc-content {
    line-height: 2;
    color: #333;
    font-size: 14px;

    h1 {
      font-size: 24px;
      color: #1d4d24;
      margin: 20px 0 15px;
      text-align: center;
      font-weight: bold;
    }

    h2 {
      font-size: 20px;
      color: #2b6e3c;
      margin: 18px 0 12px;
      font-weight: bold;
    }

    h3 {
      font-size: 18px;
      color: #2c6736;
      margin: 15px 0 10px;
      font-weight: bold;
    }

    p {
      margin: 10px 0;
      text-indent: 2em;
      text-align: justify;
    }

    ul,
    ol {
      margin: 10px 0;
      padding-left: 3em;

      li {
        margin: 5px 0;
      }
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin: 15px 0;
      background: white;

      th,
      td {
        border: 1px solid #d3e2cf;
        padding: 10px 12px;
        text-align: left;
      }

      th {
        background-color: #eef4e7;
        font-weight: bold;
        color: #1d4d24;
      }

      tr:nth-child(even) {
        background-color: #fafef7;
      }
    }

    strong,
    b {
      font-weight: bold;
      color: #1a3220;
    }

    em,
    i {
      font-style: italic;
    }
  }
}
</style>
